<template>
  <div class="w-full flex items-center gap-4">
    <div class="flex-1">
      <AppInputText
        name="search"
        :placeholder="placeholder"
        :required="false"
        @update:modelValue="$emit('searchTextChange', $event)"
      >
        <template #prefix>
          <i class="fas fa-search text-normal-reduced"></i>
        </template>
      </AppInputText>
    </div>
    <AppButtonCircle
      v-if="showFilterButton"
      icon="fa-sliders-h"
      sizeClass="w-10 h-10"
      buttonType="Secondary"
      @click="$emit('changeFilter')"
    />
  </div>
</template>
<script setup lang="ts">
import { provide, reactive } from 'vue';
import AppInputText from './AppInputText.vue';
import AppButtonCircle from './AppButtonCircle.vue';
import { ValidationContextKey } from '@/models/Context';

// Create a simple validation context
const validationContext = reactive({
  errors: new Map<string, string>(),
  validators: {} as Record<string, (key: string, validator: string) => void>,
  registerValidator: (key: string, validator: (key: string, validator: string) => void) => {
    validationContext.validators[key] = validator;
  }
});

// Provide the validation context
provide(ValidationContextKey, validationContext);

defineProps({
  placeholder: {
    type: String,
    default: 'Search events'
  },
  showFilterButton: {
    type: Boolean,
    default: true
  }
});

defineEmits<{
  (e: "searchTextChange", value: string): void;
  (e: "changeFilter"): void;
}>();
</script>
